var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{staticClass:"text-decoration-none",attrs:{"to":_vm.backRoute},domProps:{"textContent":_vm._s(_vm.$t(_vm.linkText || `productConfigBackLink.${_vm.backRouteName}`))}})
}
var staticRenderFns = []

export { render, staticRenderFns }